import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

export default class WalletStore {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "WalletStore",
      properties: [
        "wallets",
        "walletBalance",
        "walletTotalCounts",
        "selectedBusiness",
        "selectedBusinessWallet",
        "fxInflow",
        "inflowData",
        "accCreateRequest",
        "businessId",
        "outflowData",
        "foreignBankAccounts",
      ],
    });
  }

  wallets = [];
  walletTotalCounts = 0;
  walletBalance = [];
  selectedBusinessWallet = [];
  selectedBusiness = "";
  inflowData = {};
  fxInflowId = {};
  accCreateRequest = [];
  businessId = "";
  outflowData = {};
  foreignBankAccounts = [];

  reset = () => {
    this.wallets = [];
    this.walletBalance = [];
    this.walletTotalCounts = 0;
    this.selectedBusinessWallet = [];
    this.selectedBusiness = {};
    this.fxInflow = {};
    this.inflowData = {};
    this.accCreateRequest = [];
    this.businessId = "";
    this.outflowData = {};
    this.foreignBankAccounts = [];
  };

  setWallets = async (state) => {
    runInAction(() => {
      this.wallets = state;
    });
  };

  setWalletsTotalCounts = async (state) => {
    runInAction(() => {
      this.walletTotalCounts = state;
    });
  };
  setWalletBalance = async (state) => {
    runInAction(() => {
      this.walletBalance = state;
    });
  };

  setSelectedBusinessWallet = async (state) => {
    runInAction(() => {
      this.selectedBusinessWallet = state;
    });
  };
  setSelectedBusiness = async (state) => {
    runInAction(() => {
      this.selectedBusiness = state;
    });
  };

  setFxInflow = async (state) => {
    runInAction(() => {
      this.fxInflow = state;
    });
  };

  setInflowData = async (state) => {
    runInAction(() => {
      this.inflowData = state;
    });
  };

  setAccCreateRequest = async (state) => {
    runInAction(() => {
      this.accCreateRequest = state;
    });
  };

  setBusinessId = async (state) => {
    runInAction(() => {
      this.businessId = state;
    });
  };
  setOutflowData = async (state) => {
    runInAction(() => {
      this.outflowData = state;
    });
  };
  setForeignBankAccounts = async (state) => {
    runInAction(() => {
      this.foreignBankAccounts = state;
    });
  };
}
